import React, { useState } from 'react';
import Button from 'atomic/utilization/button';
import './product-description-expander.scss';

interface ProductDescriptionExpanderProps {
    parentClassName: string;
}

const ProductDescriptionExpander: React.FC<ProductDescriptionExpanderProps> = ({ parentClassName }) => {
    const [isOpen, setOpen] = useState(false);

    const click = (): void => {
        const content = document.querySelector(`.${parentClassName}`);

        if (content) {
            content.classList.add(`${parentClassName}--unfolded`);
        }

        setOpen(true);
    };

    return (
        <div className="product-description-expander">
            {!isOpen && (
                <Button onClick={click} color="blue" outline={true}
                    uppercase={true} block={true} size="md"
                    weight="600"
                >
                    Zobacz cały opis
                </Button>
            )}
        </div>
    );
};

export default ProductDescriptionExpander;
